import { useEffect, useRef } from 'react';
import Swal from 'sweetalert2';

const DeleteDialog = ({ isDeleteDialogOpen, setDeleteDialogOpen, handleDelete, title }) => {
   // Use a ref to track if the dialog is already being shown
   const isDialogShownRef = useRef(false);

   useEffect(() => {
      // Only show the dialog if it's requested to be open AND we haven't already shown it
      if (isDeleteDialogOpen && !isDialogShownRef.current) {
         // Mark that we're showing the dialog to prevent duplicates
         isDialogShownRef.current = true;

         Swal.fire({
            title: `Confirm Deletion of ${title}`,
            text: `Are you sure you want to delete this ${title}? This action cannot be undone.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#e53e3e', // red
            cancelButtonColor: '#a0aec0', // gray
            confirmButtonText: 'Yes, delete it',
         })
            .then((result) => {
               // Reset the ref and close the dialog state
               isDialogShownRef.current = false;
               setDeleteDialogOpen(false);

               // Only perform deletion if confirmed
               if (result.isConfirmed) {
                  handleDelete();
                  // Swal.fire({
                  //    icon: 'success',
                  //    title: `${title} deleted`,
                  //    showConfirmButton: false,
                  //    timer: 1000, // auto-close in 0.5 seconds
                  // });
               }
            })
            .catch(() => {
               // Reset in case of any errors
               isDialogShownRef.current = false;
               setDeleteDialogOpen(false);
            });
      } else if (!isDeleteDialogOpen) {
         // Reset the ref when dialog is explicitly closed
         isDialogShownRef.current = false;
      }
   }, [isDeleteDialogOpen, setDeleteDialogOpen, handleDelete, title]);

   return null; // No visible UI component is rendered
};

export default DeleteDialog;
